import { computed } from '@vue/composition-api'

import useCurrentInstance from './useCurrentInstance'

export default function useRoute () {
  const { vm } = useCurrentInstance()

  return computed(() => vm.proxy.$route)
}
